import type { QueryHookOptions } from "@apollo/client";
import { useQuery, useLazyQuery, gql } from "@apollo/client";

const GET_CURRENT_USER = gql`
  query User_UnauthenticatedOAuth_Query {
    viewer {
      user {
        id
        currentUserRole
      }
    }
  }
`;

interface CurrentUserData {
  viewer: {
    user: {
      id: string;
      currentUserRole: string;
    };
  };
}

const useCurrentUserQuery = (options?: QueryHookOptions<CurrentUserData>) =>
  useQuery<CurrentUserData>(GET_CURRENT_USER, options);

const useCurrentUserLazyQuery = (options?: QueryHookOptions<CurrentUserData>) =>
  useLazyQuery<CurrentUserData>(GET_CURRENT_USER, options);

export type { CurrentUserData };
export { useCurrentUserQuery, useCurrentUserLazyQuery, GET_CURRENT_USER };
